/**
 * Converts a number into French words (Algerian Dinar context).
 * Simplified version for common currency amounts.
 */
export function numberToWords(amount) {
    if (amount === 0) return "Zéro Dinar";

    const units = ["", "Un", "Deux", "Trois", "Quatre", "Cinq", "Six", "Sept", "Huit", "Neuf"];
    const tens = ["", "Dix", "Vingt", "Trente", "Quarante", "Cinquante", "Soixante", "Soixante-Dix", "Quatre-Vingt", "Quatre-Vingt-Dix"];
    const teens = ["Dix", "Onze", "Douze", "Treize", "Quatorze", "Quinze", "Seize", "Dix-Sept", "Dix-Huit", "Dix-Neuf"];

    function convertGroup(n) {
        let res = "";
        const h = Math.floor(n / 100);
        const t = Math.floor((n % 100) / 10);
        const u = n % 10;

        if (h > 0) {
            if (h === 1) res += "Cent ";
            else res += units[h] + " Cent ";
        }

        if (t === 1) {
            res += teens[u] + " ";
        } else if (t > 1) {
            if (t === 7 || t === 9) {
                res += tens[t - 1] + "-" + teens[u] + " ";
            } else {
                res += tens[t] + (u === 1 ? " et Un " : u > 0 ? "-" + units[u] + " " : " ");
            }
        } else if (u > 0) {
            res += units[u] + " ";
        }

        return res.trim();
    }

    const million = Math.floor(amount / 1000000);
    const thousand = Math.floor((amount % 1000000) / 1000);
    const rest = Math.floor(amount % 1000);
    const centimes = Math.round((amount % 1) * 100);

    let result = "";

    if (million > 0) {
        result += convertGroup(million) + (million > 1 ? " Millions " : " Million ");
    }

    if (thousand > 0) {
        if (thousand === 1) result += "Mille ";
        else result += convertGroup(thousand) + " Mille ";
    }

    if (rest > 0) {
        result += convertGroup(rest) + " ";
    }

    result = result.trim() + " Dinar Algérien";
    if (Math.floor(amount) > 1) result += "s";

    if (centimes > 0) {
        result += " et " + convertGroup(centimes) + " Centime";
        if (centimes > 1) result += "s";
    } else {
        result += " et Zéro Centime";
    }

    return result;
}
